import { ValidationProvider, ValidationService } from "aspnet-client-validation";

//NOTE: This must match up with the server-side implementation!

/** The 'must be true' provider name */
export const PROVIDER_NAME: string = "filetype";

/**
 * Adds the 'must be true' provider to the validation service
 * @param validation The validation service
 */
export function addFileTypeProvider(validation: ValidationService)
{
    validation.addProvider(PROVIDER_NAME, provider);
}

/**
 * A validation provider that validates that a boolean must be true
 */
export const provider: ValidationProvider = (value, element, params) =>
{
    if (value == null)
        return true; //Let [Required] handle empty input first

    const extensions: string[] = params["extensions"].split(",");

    if (element instanceof HTMLInputElement)
    {
        if (element.files == null || element.files.length === 0)
            return true; //Let [Required] handle empty input first

        //See if the file extensions match the accepted extensions
        for (const file of element.files)
        {
            const fileExtension: string = getFileExtension(file.name);

            for (const extension of extensions)
            {
                if (extension.localeCompare(fileExtension, undefined, { sensitivity: "accent" }) === 0)
                    return true;
            }

            //No extensions matched
            return false;
        }

        //No files were present
        return true;
    }
    else
    {
        return "Invalid input element";
    }
};

function getFileExtension(fileName: string): string
{
    const dotIndex: number = fileName.lastIndexOf(".");

    if (dotIndex === -1)
        return "";
    else
        return fileName.substring(dotIndex);
}
